var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to)?_c('router-link',{staticClass:"textual-button",attrs:{"to":_vm.to}},[_vm._t("default"),_c('unicon',{attrs:{"name":"angle-right"}})],2):_c('button',{staticClass:"textual-button"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }